export default __webpack_public_path__ + "static/media/homeScene_4.9266b4c5.png";